import { calculateChartFromChartData } from 'vio-libs';
export function calculateSiteChartsFromChartsDictionaryData(chartsDictionaryData, title) {
    const siteCharts = {};
    const keys = Object.keys(chartsDictionaryData);
    if (keys.length < 1) {
        return undefined;
    }
    for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const chartData = chartsDictionaryData[key];
        const calculatedChartData = calculateChartFromChartData(chartData);
        siteCharts[key] = Object.assign(Object.assign({}, calculatedChartData), { title: `${title} (${key})` });
    }
    return siteCharts;
}
export function calculateNetworkInterfacesChartData(networkInterfacesCharts, selectedKeys) {
    if (selectedKeys.length === 0) {
        return undefined;
    }
    try {
        const mostEntriesKey = Object.keys(networkInterfacesCharts).reduce((a, b) => {
            const firstItem = networkInterfacesCharts[a].entries;
            const secondItem = networkInterfacesCharts[b].entries;
            if (!firstItem && secondItem) {
                return b;
            }
            return firstItem.length >= secondItem.length ? a : b;
        });
        const data = networkInterfacesCharts[mostEntriesKey];
        const title = data.title.split(' ')[0];
        const { unit } = data;
        const dataKey = Object.keys(data.entries[0]).filter(entry => {
            return entry !== 'label';
        })[0];
        const dataLabels = data.entries.map(entry => entry.label);
        const dataLen = data.entries.length;
        const chartData = {
            entries: Array.from({
                length: dataLen
            }, () => ({})),
            title,
            unit
        };
        for (let i = 0; i < selectedKeys.length; i += 1) {
            const networkInterface = selectedKeys[i];
            const networkInterfaceEntries = networkInterfacesCharts[networkInterface].entries;
            let entryIndex = 0;
            for (let j = 0; j < chartData.entries.length; j += 1) {
                const entry = networkInterfaceEntries && networkInterfaceEntries[entryIndex];
                chartData.entries[j].label = dataLabels[j];
                if (entry && chartData.entries[j].label === entry.label) {
                    chartData.entries[j][networkInterface] = entry[dataKey];
                    entryIndex += 1;
                }
                else {
                    chartData.entries[j][networkInterface] = undefined;
                }
            }
        }
        return chartData;
    }
    catch (_a) {
        return undefined;
    }
}
